import React, { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { Quote, ArrowLeft, ArrowRight } from "lucide-react";
import { SectionLabel } from "./Shared";
import { TESTIMONIALS } from "../config/siteConfig";

export const Testimonials = () => {
  const [idx, setIdx] = useState(0);
  const t = TESTIMONIALS[idx];
  const go = (dir) => setIdx((p) => (p + dir + TESTIMONIALS.length) % TESTIMONIALS.length);

  return (
    <section className="bg-[#F7F7F5] py-24 md:py-36" data-testid="testimonials-section">
      <div className="max-w-5xl mx-auto px-6 lg:px-8">
        <SectionLabel center>Client Voices</SectionLabel>
        <div className="text-center">
          <Quote size={56} className="mx-auto text-[#C62828] mb-8" strokeWidth={1.2} />
          <div className="min-h-[220px] md:min-h-[200px] flex items-center justify-center">
            <AnimatePresence mode="wait">
              <motion.blockquote
                key={idx}
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                exit={{ opacity: 0, y: -20 }}
                transition={{ duration: 0.5 }}
                data-testid="testimonial-quote"
                className="font-display text-2xl md:text-4xl leading-snug text-[#111111] max-w-4xl"
              >
                &ldquo;{t.quote}&rdquo;
              </motion.blockquote>
            </AnimatePresence>
          </div>
          <div className="mt-10">
            <p className="font-body font-600 text-[#111111]">{t.name}</p>
            <p className="font-body text-sm text-[#555]">{t.title}, {t.company}</p>
          </div>
        </div>

        <div className="flex items-center justify-center gap-4 mt-12">
          <button
            onClick={() => go(-1)}
            data-testid="testimonial-prev"
            aria-label="Previous testimonial"
            className="w-12 h-12 rounded-full border border-black/15 flex items-center justify-center hover:border-[#C62828] hover:text-[#C62828] transition-colors"
          >
            <ArrowLeft size={18} />
          </button>
          <div className="flex gap-2">
            {TESTIMONIALS.map((_, i) => (
              <button
                key={i}
                onClick={() => setIdx(i)}
                data-testid={`testimonial-dot-${i}`}
                aria-label={`Go to testimonial ${i + 1}`}
                className={`h-2 rounded-full transition-all duration-300 ${i === idx ? "w-8 bg-[#C62828]" : "w-2 bg-black/20"}`}
              />
            ))}
          </div>
          <button
            onClick={() => go(1)}
            data-testid="testimonial-next"
            aria-label="Next testimonial"
            className="w-12 h-12 rounded-full border border-black/15 flex items-center justify-center hover:border-[#C62828] hover:text-[#C62828] transition-colors"
          >
            <ArrowRight size={18} />
          </button>
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
